export default __webpack_public_path__ + "static/projector-sound-0cc3833e76ed5b62769d510656420d6e.mp3";